import wm from './wmStore.js';
import { toast } from './toastStore.js';
/**
 * picks.js — tiny dispatch helpers for the global detail modals.
 *
 * Any widget can call `pickItem("Dreugh Wax")` to surface the
 * ItemDetailModal, `pickUser("@FissalBatesi")` to surface the
 * UserDetailModal, etc.  The modals listen for the corresponding
 * CustomEvents on `window`.
 *
 * Issue #89 — pickItem accepts an optional `{ icon }` (and reserved
 * `{ levelKey, itemID }`) hint so the popup renders the EXACT icon
 * shown on the clicked row, not the first MM_Items match by name
 * (which often differs for variant items sharing a display name).
 */

export function pickItem(name, opts) {
  if (!name) return;
  const detail = { name: String(name) };
  if (opts && opts.icon)     detail.icon     = String(opts.icon);
  if (opts && opts.levelKey) detail.levelKey = String(opts.levelKey);
  if (opts && opts.itemID != null) detail.itemID = opts.itemID;
  window.dispatchEvent(new CustomEvent('v2-item-pick', { detail }));
}

export function canInspectUser(tagOrName) {
  if (!tagOrName) return false;
  const ident = wm?.state?.identity;
  if (ident?.isAdmin) return true;
  const ownTag = String(ident?.tag || '').trim().replace(/^@+/, '').toLowerCase();
  const targetTag = String(tagOrName).trim().replace(/^@+/, '').toLowerCase();
  return Boolean(ownTag && ownTag === targetTag);
}

export function pickUser(tagOrName) {
  if (!tagOrName) return;
  const tag = String(tagOrName).trim();
  if (!canInspectUser(tag)) {
    toast.info('Inspecting other players is restricted to Redfur staff.', { ttl: 2200 });
    return;
  }
  window.dispatchEvent(new CustomEvent('v2-user-pick', { detail: { tag } }));
}

export function pickGuild(idOrName, opts) {
  if (!idOrName) return;
  const detail = typeof idOrName === 'number' ? { guildId: idOrName } : { name: String(idOrName) };
  if (opts && Number.isFinite(Number(opts.weekOffset))) detail.weekOffset = Number(opts.weekOffset);
  window.dispatchEvent(new CustomEvent('v2-guild-pick', {
    detail,
  }));
}
